import BaseTypesenseSearch from '../typesense-search';
import {
  getConventionCollectiveClearRefinements,
  getConventionCollectiveHitsWidgets,
  getConventionCollectiveMenuWidgets,
  getConventionCollectiveSearchBoxWidgets,
} from './convention-collective-widgets';
import { Widget } from 'instantsearch.js';
import { CategoriesOrder } from '../types';
import { configure } from 'instantsearch.js/es/widgets';

export default class ConventionCollective extends BaseTypesenseSearch {
  private resultHitsContainer: HTMLDivElement | null = null;
  private searchBoxContainer: HTMLDivElement | null = null;
  private menuCategoriesContainer: HTMLDivElement | null = null;
  private categoriesOrder: CategoriesOrder[] = [];
  private clearRefinementsContainer: HTMLDivElement | null = null;
  private setTimeoutId: ReturnType<typeof setTimeout>;

  constructor() {
    super();
    this.setTimeoutId = 0;
  }

  getWidgets() {
    return [
      this.resultHitsContainer ? getConventionCollectiveHitsWidgets(this.resultHitsContainer) : null,
      this.searchBoxContainer ? getConventionCollectiveSearchBoxWidgets(this.searchBoxContainer) : null,
      this.menuCategoriesContainer ? getConventionCollectiveMenuWidgets(this.menuCategoriesContainer, this.categoriesOrder) : null,
      this.clearRefinementsContainer ? getConventionCollectiveClearRefinements(this.clearRefinementsContainer) : null,
      this.configureParams ? configure(this.configureParams) : null,
    ].filter(Boolean) as Widget[];
  }

  // Show result in viewport
  showResult() {
    // Check if the result header is in the viewport
    // if not, scroll
    if (this.setTimeoutId) clearTimeout(this.setTimeoutId);
    this.setTimeoutId = setTimeout(() => {
      const hitsHeaderPosY = this.clearRefinementsContainer?.getBoundingClientRect()?.top;
      const mainHeaderHeight = document.querySelector('#main-header')?.getBoundingClientRect()?.height ?? 0;
      const targetTop = mainHeaderHeight + 80;
      if (hitsHeaderPosY && hitsHeaderPosY <= 0) window.scrollTo({ top: targetTop, left: 0, behavior: 'smooth' });
    }, 250);
  }

  onSearchInstanceRender() {
    this.showResult();
  }

  init() {
    const { categoriesOrder } = this.dataset;
    this.resultHitsContainer = this.querySelector('.result-hits');
    this.searchBoxContainer = this.querySelector('.search-box-container');
    this.menuCategoriesContainer = this.querySelector('.menu-categories-container');
    this.clearRefinementsContainer = this.querySelector('.result-hits-header');

    try {
      const parsed = JSON.parse(`${categoriesOrder}`);
      this.categoriesOrder = Object.values(parsed);
    } catch (e: unknown) {
      console.warn('Error while parsing categoriesOrder', (e as Error).message);
    }

    this.searchInstance?.on('render', this.onSearchInstanceRender.bind(this));
    this.searchInstance?.start();
    this.searchInstance?.addWidgets(this.getWidgets());
  }

  connectedCallback() {
    setTimeout(() => {
      this.initSearchInstance();
      this.init();
    });
  }
}